import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { CalendarMonth as CalendarIcon, ViewList as ListIcon } from '@mui/icons-material';
import AppointmentList from './AppointmentList';
import AppointmentCalendar from './AppointmentCalendar';

const AppointmentView = () => {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange} 
          aria-label="appointment view tabs"
          centered
        >
          <Tab icon={<ListIcon />} label="List View" />
          <Tab icon={<CalendarIcon />} label="Calendar View" />
        </Tabs>
      </Box>
      
      {activeTab === 0 && (
        <AppointmentList />
      )}
      
      {activeTab === 1 && (
        <AppointmentCalendar />
      )}
    </Box>
  );
};

export default AppointmentView;